import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n)

const loadLocaleMessages = () => {
  const locales = require.context(
    '../locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([a-z0-9]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export const i18n = new VueI18n({
  locale:process.env.VUE_APP_DEFAULT_LANGUAGE, // set locale
  fallbackLocale:process.env.VUE_APP_FALLBACK_LANGUAGE,
  messages:loadLocaleMessages(),
  silentTranslationWarn:true,
})

/**
 * @param {String} locale
 */
export async function loadMessages(locale) {
  if (Object.keys(i18n.getLocaleMessage(locale)).length === 0) {
    const messages = await import(`@/locales/${locale}`)
    i18n.setLocaleMessage(locale, messages)
  }

  i18n.locale = locale
}

(async function () {
  let locale = 'en'
  await loadMessages(locale)
})()

export default i18n
